module.exports = __webpack_public_path__ + "static/media/UpDown.f317e726.jpeg";